import { useFormContext, Controller } from 'react-hook-form'
import { Spacer, Select } from '@cb/apricot-react'
import { CBInputMethod } from '@cb/apricot'
import { PARENTEDU_OPTIONS } from '@myap/metadata'
import { FIELD_PARENT1, FIELD_PARENT2 } from '../constants'
import { validateFieldState } from '../validations'

import styles from '../profileandregform.module.scss'

function ParentalEducation({ disabled }) {
  const { control } = useFormContext()

  useEffect(() => {
    CBInputMethod()
  }, [])

  return (
    <fieldset aria-labelledby="parental_education_legend" aria-required="true" aria-invalid="false">
      <legend
        id="parental_education_legend"
        className={`cb-label cb-required${disabled ? ' cb-text-disabled' : ''} ${
          styles['legend-section']
        }`}
      >
        Parental Education Level
      </legend>
      <Spacer size="8" />
      <p className={disabled ? 'cb-text-disabled' : ''}>
        <strong>Please indicate your parent or guardian&#39;s highest level of education.</strong>
        <br />
        <span className="cb-font-size-small">
          (If you have two parents/guardians, describe the level of education for both.)
        </span>
      </p>
      <Controller
        control={control}
        name={FIELD_PARENT1}
        disabled={disabled}
        rules={{ required: 'Parent or guardien education level is required' }}
        render={({
          field: { onChange, onBlur, value, disabled, name },
          fieldState: { invalid, isDirty, isTouched, error },
        }) => (
          <Select
            name={name}
            label="Parent or guardian 1"
            labelNoValue="Make a selection"
            required
            disabled={disabled}
            onChange={value => onChange(value)}
            onBlur={value => onBlur(value)}
            value={value}
            values={PARENTEDU_OPTIONS}
            validation={validateFieldState({
              invalid,
              isDirty,
              isTouched,
              error,
              value,
            })}
            validationMsg={error?.message}
          />
        )}
      />
      <Spacer size="24" />
      <Controller
        control={control}
        name={FIELD_PARENT2}
        disabled={disabled}
        render={({
          field: { onChange, onBlur, value, disabled, name },
          fieldState: { invalid, isDirty, isTouched, error },
        }) => (
          <Select
            name={name}
            label="Parent or guardian 2"
            labelNoValue="Make a selection"
            disabled={disabled}
            onChange={value => onChange(value)}
            onBlur={value => onBlur(value)}
            value={value}
            values={PARENTEDU_OPTIONS}
            validation={validateFieldState({
              invalid,
              isDirty,
              isTouched,
              error,
              value,
            })}
            validationMsg={error?.message}
          />
        )}
      />
    </fieldset>
  )
}

export default ParentalEducation
